import { render, staticRenderFns } from "./OppregForm.vue?vue&type=template&id=49db4d8e&scoped=true&"
import script from "./OppregForm.vue?vue&type=script&lang=js&"
export * from "./OppregForm.vue?vue&type=script&lang=js&"
import style0 from "./OppregForm.vue?vue&type=style&index=0&id=49db4d8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49db4d8e",
  null
  
)

export default component.exports